(() => { const motion=matchMedia('(prefers-reduced-motion: reduce)');const communityPage=!!document.querySelector('.nhny-community-page');const communityStrip=document.querySelector('#community-strip');if(!communityStrip)return;
const communityPhotos=[...communityStrip.children];
if(!communityPage&&communityPhotos.length){
 const communitySection=communityStrip.closest('.community');
 // Copies on both sides let the scroll position wrap without a visible jump.
 const clonePhoto=photo=>{const clone=photo.cloneNode(true);clone.setAttribute('aria-hidden','true');clone.tabIndex=-1;return clone;};
 communityStrip.prepend(...communityPhotos.map(clonePhoto));
 communityStrip.append(...communityPhotos.map(clonePhoto));
 let cycleWidth=0,lastFrame=0,motionRemainder=0,frameId=0,inView=false,pointerHeld=false,pointerOver=false,resumeAt=0;
 const measureCycle=()=>{
  const progress=cycleWidth?(communityStrip.scrollLeft-cycleWidth)/cycleWidth:0;
  cycleWidth=communityStrip.children[communityPhotos.length*2].offsetLeft-communityStrip.children[communityPhotos.length].offsetLeft;
  if(cycleWidth)communityStrip.scrollLeft=cycleWidth*(1+progress);
 };
 const wrapCommunityScroll=()=>{
  if(!cycleWidth)return;
  if(communityStrip.scrollLeft>=cycleWidth*2)communityStrip.scrollLeft-=cycleWidth;
  else if(communityStrip.scrollLeft<=0)communityStrip.scrollLeft+=cycleWidth;
 };
 measureCycle();
 communityStrip.addEventListener('scroll',wrapCommunityScroll,{passive:true});
 window.addEventListener('resize',measureCycle);
 const pauseCommunityMotion=(delay=4500)=>{resumeAt=performance.now()+delay;lastFrame=0;};
 const animateCommunity=time=>{
  frameId=requestAnimationFrame(animateCommunity);
  if(pointerHeld||(pointerOver&&communityStrip.matches(':hover'))||communitySection.matches(':focus-within')||time<resumeAt){lastFrame=time;return;}
  if(!cycleWidth){lastFrame=time;return;}
  const elapsed=lastFrame?Math.min(50,time-lastFrame):0;
  lastFrame=time;
  motionRemainder+=elapsed*.028;
  const step=Math.trunc(motionRemainder);
  if(step){communityStrip.scrollLeft+=step;motionRemainder-=step;wrapCommunityScroll();}
 };
 const updateCommunityMotion=()=>{
  const shouldRun=inView&&!document.hidden&&!motion.matches;
  if(shouldRun&&!frameId)frameId=requestAnimationFrame(animateCommunity);
  else if(!shouldRun&&frameId){cancelAnimationFrame(frameId);frameId=0;lastFrame=0;}
 };
 new IntersectionObserver(([entry])=>{inView=entry.isIntersecting;updateCommunityMotion();},{threshold:.1}).observe(communityStrip);
 document.addEventListener('visibilitychange',updateCommunityMotion);
 motion.addEventListener('change',updateCommunityMotion);
 communityStrip.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse')pointerOver=true;});
 communityStrip.addEventListener('pointerleave',event=>{if(event.pointerType==='mouse'){pointerOver=false;pauseCommunityMotion(1800);}});
 communityStrip.addEventListener('focusout',()=>pauseCommunityMotion(3000));
 let drag,suppressDragClick=false;
 communityStrip.addEventListener('dragstart',event=>event.preventDefault());
 communityStrip.addEventListener('pointerdown',event=>{pointerHeld=true;suppressDragClick=false;pauseCommunityMotion();if(event.pointerType==='mouse'&&event.button===0)drag={id:event.pointerId,x:event.clientX,moved:false};});
 communityStrip.addEventListener('pointermove',event=>{if(!drag||drag.id!==event.pointerId||!(event.buttons&1))return;const delta=event.clientX-drag.x;if(Math.abs(delta)>5||drag.moved){drag.moved=true;communityStrip.setPointerCapture(event.pointerId);communityStrip.scrollLeft-=delta;wrapCommunityScroll();drag.x=event.clientX;}});
 communityStrip.addEventListener('click',event=>{if(suppressDragClick){event.preventDefault();event.stopPropagation();suppressDragClick=false;}},true);
 communityStrip.addEventListener('pointerup',()=>{pointerHeld=false;suppressDragClick=!!drag?.moved;drag=null;if(suppressDragClick)setTimeout(()=>{suppressDragClick=false;},0);pauseCommunityMotion();});
 communityStrip.addEventListener('pointercancel',()=>{pointerHeld=false;drag=null;pauseCommunityMotion();});
}

if(communityPage){
 const columns=[...communityStrip.querySelectorAll(':scope > .community-column')];
 if(!columns.length)return;
 const cloneColumn=column=>{const clone=column.cloneNode(true);clone.setAttribute('aria-hidden','true');clone.querySelectorAll('a').forEach(link=>link.tabIndex=-1);clone.querySelectorAll('img').forEach(img=>img.loading='lazy');return clone;};
 communityStrip.replaceChildren(...columns.map(cloneColumn),...columns,...columns.map(cloneColumn));
 let cycleWidth=0,position=0,frameId=0,lastTime=0,inView=false,drag=null,pointerHeld=false,pauseUntil=0,suppressClick=false;
 const measure=()=>{
  const progress=cycleWidth?(communityStrip.scrollLeft-cycleWidth)/cycleWidth:0;
  cycleWidth=communityStrip.children[columns.length*2].offsetLeft-communityStrip.children[columns.length].offsetLeft;
  if(cycleWidth)communityStrip.scrollLeft=cycleWidth*(1+progress);position=communityStrip.scrollLeft;
 };
 const wrap=()=>{if(!cycleWidth)return;if(communityStrip.scrollLeft>=cycleWidth*2)communityStrip.scrollLeft-=cycleWidth;else if(communityStrip.scrollLeft<=0)communityStrip.scrollLeft+=cycleWidth;position=communityStrip.scrollLeft;};
 measure();window.addEventListener('resize',measure);
 const videos=[...communityStrip.querySelectorAll('video')];
 const videoObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{
  const video=entry.target;video.dataset.visible=String(entry.isIntersecting);
  if(entry.isIntersecting&&inView&&!motion.matches&&!document.hidden){if(!video.src)video.src=video.dataset.src;video.play().catch(()=>{});}
  else video.pause();
 }),{root:communityStrip,threshold:.1});
 videos.forEach(video=>videoObserver.observe(video));
 const syncVideos=()=>videos.forEach(video=>{if(!inView||document.hidden||motion.matches)video.pause();else if(video.dataset.visible==='true'){if(!video.src)video.src=video.dataset.src;video.play().catch(()=>{});}});
 const animate=time=>{
  frameId=requestAnimationFrame(animate);
  if(pointerHeld||drag||time<pauseUntil){lastTime=0;position=communityStrip.scrollLeft;return;}
  position+=(lastTime?Math.min(50,time-lastTime):0)*.032;lastTime=time;
  if(cycleWidth&&position>=cycleWidth*2)position-=cycleWidth;
  communityStrip.scrollLeft=position;
 };
 const sync=()=>{
  if(inView&&!document.hidden&&!motion.matches){if(!frameId){position=communityStrip.scrollLeft;frameId=requestAnimationFrame(animate);}}
  else if(frameId){cancelAnimationFrame(frameId);frameId=0;lastTime=0;}
  syncVideos();
 };
 new IntersectionObserver(([entry])=>{inView=entry.isIntersecting;sync();},{threshold:.1}).observe(communityStrip);
 document.addEventListener('visibilitychange',sync);motion.addEventListener('change',sync);
 communityStrip.addEventListener('dragstart',event=>event.preventDefault());
 communityStrip.addEventListener('pointerdown',event=>{pointerHeld=true;pauseUntil=performance.now()+3000;if(event.pointerType==='mouse'&&event.button===0)drag={id:event.pointerId,x:event.clientX,moved:false};});
 communityStrip.addEventListener('pointermove',event=>{
  if(!drag||drag.id!==event.pointerId||!(event.buttons&1))return;
  const delta=event.clientX-drag.x;
  if(Math.abs(delta)>5||drag.moved){drag.moved=true;communityStrip.setPointerCapture(event.pointerId);communityStrip.scrollLeft-=delta;wrap();drag.x=event.clientX;}
 });
 const releasePointer=()=>{pointerHeld=false;suppressClick=!!drag?.moved;drag=null;pauseUntil=performance.now()+2000;if(suppressClick)setTimeout(()=>{suppressClick=false;},0);};
 window.addEventListener('pointerup',releasePointer);
 window.addEventListener('pointercancel',releasePointer);
 communityStrip.addEventListener('click',event=>{if(suppressClick){event.preventDefault();event.stopPropagation();suppressClick=false;}},true);
 communityStrip.addEventListener('wheel',()=>{pauseUntil=performance.now()+2000;},{passive:true});
}
})();
